export const LANDING_NAV_ITEMS = [
  { label: 'Home', to: '/' },
  { label: 'About LMW', to: '/about' },
  { label: 'Explorer', to: '/search' },
  { label: 'Data Center', to: '/data-center' },
  { label: 'Methodology', to: '/methodology' },
]

export const isLandingNavActive = (pathname, target) => {
  if (target === '/') return pathname === '/'
  if (target === '/search') return pathname.startsWith('/search')
  return pathname === target
}
